import { render, staticRenderFns } from "./PaymentMethodItem.vue?vue&type=template&id=3884e6a5&scoped=true"
import script from "./PaymentMethodItem.vue?vue&type=script&lang=js"
export * from "./PaymentMethodItem.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodItem.vue?vue&type=style&index=0&id=3884e6a5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3884e6a5",
  null
  
)

export default component.exports